import React from "react";
import { Modal, Row, Col, Button } from "antd";
import styles from "../FooterComponent/Footer.module.scss";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";

type Props = {
  isContactUsModalVisible: boolean;
  setIsContactUsModalVisible: Function;
};

export default function WandaContactUsModal(props: Props) {
  const { isContactUsModalVisible, setIsContactUsModalVisible } = props;
  const { customerCareDetails } = usePersonSummaryCtx();
  return (
    <>
      <Modal
        className={styles.contactUsModalContainer}
        visible={isContactUsModalVisible}
        centered={true}
        width="unset"
        footer={
          <Row justify="center">
            <Col>
              <Button
                id={styles.modalCloseBtn}
                onClick={() => setIsContactUsModalVisible(false)}
              >
                Close
              </Button>
            </Col>
          </Row>
        }
      >
        <Row>
          <Col span={24} className={styles.contactUsModalTitle}>
            Contact Us
          </Col>
          <Col span={24} className={styles.contactUsModalSideHeading}>
            Email Address
          </Col>
          <Col span={24} className={styles.contactUsModalDescription}>
            {customerCareDetails.wandaCustomerCareMailAddress}
          </Col>
          <Col
            span={24}
            className={`${styles.contactUsModalSideHeading} ${styles.contactUsModalLineBreak}`}
          >
            Phone Number
          </Col>
          <Col span={24} className={styles.contactUsModalDescription}>
            {customerCareDetails.wandaCustomerCareNumber}
          </Col>
          <Col
            span={24}
            className={`${styles.contactUsModalTimings} ${"subTextFont"}`}
          >
            {customerCareDetails.wandaCustomerCareTimings}
          </Col>
        </Row>
      </Modal>
    </>
  );
}
